










import { Component, Vue } from "@/shared/node_modules/vue-property-decorator";
import store from "@/shared/core/store";
import { Settings } from "@/shared/core/services/configService";
import { CrudService } from "@/shared/core/services/crudService";
import { CustomerHelper } from "@/shared/crm/helpers/customerHelper";
import { ShopService } from "@/shared/core/services/shopService";
import { markFromWhatsApp } from "@/shared/core/whatsappPay";
import { LocalStorage } from "@/shared/core/localStorage";

@Component({
  components: {},
})
export default class WhatsappPayPage extends Vue {
  errorMsg: string = "";

  async created() {
    markFromWhatsApp();
    const token = this.$route.query.t;
    if (typeof token !== "string" || token === "") {
      this.errorMsg = this.$t("Wrong access").toString();
      return;
    }

    try {
      // The link is single-use: let a pending front version reload happen before spending it.
      const versionKey = window.location.host + "_czv";
      const version = localStorage.getItem(versionKey);
      await new CrudService().httpGet(`${Settings.HostName}/api/shop/list?startRow=0&endRow=1`);
      if (localStorage.getItem(versionKey) !== version) {
        return;
      }

      // Keep the token out of the address bar, history and error reports from here on.
      window.history.replaceState(null, "", this.$route.path);

      const data = await new CrudService().httpPost(`${Settings.HostName}/api/public-whatsapp-pay/redeem`, { token });
      if (data === null || data === undefined || data.ok !== true) {
        this.errorMsg = data && data.errorMsg ? data.errorMsg : this.$t("Wrong access").toString();
        return;
      }

      CustomerHelper.clearLocalSession();
      new ShopService().removeCart();
      // Checkout would book a half-finished selection left in this browser for the WhatsApp patient.
      LocalStorage.delete("pendingBooking");
      await CustomerHelper.saveLogedCustomer(data.model.token, data.model.expiry, data.model.id, data.model.logo, data.model.name, data.model.surname);
      store.state.loggedIn = true;

      const sale = data.sale;
      sale.title = sale.description;
      sale.cancelUrl = `publicbookings/cancel/${sale.bookingId}/${sale.customerId}`;
      new ShopService().addSaleToCart(sale, null);
      this.$router.replace("/checkout");
    } catch (e) {
      this.errorMsg = this.$t("Ups something went wrong Please try again").toString();
    }
  }
}
